<template>
    <section>
        <modal v-if="showModal" @close="cancel"
            title="Agregar zona"
            :sizeOfModal="'small'"
            :showElement="showModal">
            <template v-slot:modalContent>
                <sui-form @submit.prevent>
                    <sui-form-field :error="isDuplicateZoneName" required>
                        <label>Nombre</label>
                        <sui-input type="text" v-model="record.name" />
                        <span v-if="isDuplicateZoneName">Ya existe una zona con ese nombre</span>
                    </sui-form-field>
                </sui-form>
                <sui-message info size="small">
                    <i class="info circle icon"></i>
                    Una zona puede representar un municipio, ciudad, colonias o grupo de códigos postales.
                </sui-message>
            </template>
            <template v-slot:modalFooter>
                <div class="actions">
                    <sui-button primary :disabled="isDuplicateZoneName || !record.name.trim()" @click="confirm">
                        Crear Zona
                    </sui-button>
                    <sui-button @click="cancel">Cerrar</sui-button>
                </div>
            </template>
        </modal>
    </section>
</template>

<script>
import Modal from '@/components/Helpers/Modal.vue'

export default {
    name: 'AddZoneModal',
    components: { Modal },
    props: ['showModal', 'zones'],

    data () {
        return {
            record: { name: '', cancel: false }
        }
    },

    computed: {
        isDuplicateZoneName () {
            const name = this.record.name.trim().toLowerCase()
            if (!name) return false
            return (this.zones || []).some(z => z.name.trim().toLowerCase() === name)
        }
    },

    watch: {
        showModal (val) {
            if (val) this.record = { name: '', cancel: false }
        }
    },

    methods: {
        confirm () {
            this.record.cancel = false
            this.$emit('modalResponse', this.record)
        },
        cancel () {
            this.record.cancel = true
            this.$emit('modalResponse', this.record)
        }
    }
}
</script>
